module.exports = __webpack_public_path__ + "img/top-4-0.f926e224.jpg";